import { PackagePatternConfigDetail } from "@/features/operation-package-config-new/PackagePatternDetail";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/contractor-core/config/$patternId/",
)({
  component: PatternDetailPage,
});

function PatternDetailPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.contractorCore.operationPackages",
  });
  const { patternId } = useParams({
    from: "/_staff/contractor-core/config/$patternId/",
  });

  return (
    <>
      <PackagePatternConfigDetail
        ownerProduct="HRF_CONTRACTOR_CORE"
        breadcrumbs={[
          {
            linkTo: "/contractor-core/configs",
            label: t("contractorCore"),
          },
        ]}
        patternId={patternId}
      />
    </>
  );
}
